module.exports = __webpack_public_path__ + "img/flag_sco.086db759.png";